import { ConfirmModal } from 'components/modal/ConfirmModal';
import { Pagination } from 'components/pagination/Pagination';
import { Typography, closeModal, openModal } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { LevelLessonModal } from 'modules/dashboard/components/LevelLessonModal';
import { Exercises } from 'modules/dashboard/core/type';
import { CustomTypography } from 'modules/dashboard/styles/card-item';
import { Grid_6 } from 'modules/dashboard/styles/functional-test';

import { isEmpty } from 'lodash';

import { TABLE_KEY } from 'constants/table';

import { CardItem } from '../components/CardItem';
import { Header } from '../components/Header';
import { useExercisesController } from '../core/controller/exercises';
import { ExerciseContentCategory } from '../core/enum';
import { useLibrary } from '../core/hook';

export const ExercisesPage = () => {
  const {
    exercisesData,
    total,
    queryState,
    onChangeSelectedExercises,
    selectedExercises,
    setSelectedExercises,
    handleDelete,
    lessonsData,
    searchValue,
    handleAddToLesson,
    searchExercise,
    onChangeSearchExcercise,
    onChangeSearchValue,
    handleEditExercise,
    handleDeleteExercise,
    goToExerciseDetail,
    onDeleteExercise,
    hideAction,
    handleDuplicateExercise,
    levelLesson,
    setLevelLesson,
    showLevelLessonModal,
    onCancel,
  } = useExercisesController();

  const { onClickAddItem } = useLibrary();

  const selectedExercisesTotal = Object.keys(selectedExercises).length;

  const showCheckbox = !isEmpty(Object.keys(selectedExercises));
  const cardTag = (el: Exercises) =>
    [`Level ${el.level}`, `${el.upperBody}% upper`, `${el.lowerBody}% lower`].map(
      (text, tagIndex) => <CustomTypography key={tagIndex}>{text}</CustomTypography>,
    );

  return (
    <div>
      <Header
        selected={selectedExercises}
        title="Add to lesson"
        placeholderSearch="Search by lesson"
        options={lessonsData}
        setSelected={setSelectedExercises}
        onDelete={() => openModal(MODAL_KEY.DELETE_EXERCISE)}
        searchValueBySelected={searchValue.value}
        onAdd={showLevelLessonModal}
        type="exercise, category"
        searchValue={searchExercise.value}
        onChangeSearch={onChangeSearchExcercise}
        onChangeSearchBySelected={onChangeSearchValue}
        hideDeleteAction={hideAction}
        onClickAddItem={onClickAddItem}
        closeModal={true}
      />
      {exercisesData.length > 0 ? (
        <>
          <Grid_6>
            {exercisesData.map((el, index) => {
              const selected = Boolean(selectedExercises[el.id]);

              const isWarmupOrCooldownOrCheerup =
                el.category.key === ExerciseContentCategory.WARMUP ||
                el.category.key === ExerciseContentCategory.COOLDOWN ||
                el.category.key === ExerciseContentCategory.MIDPOINTCHEERUP ||
                el.category.key === ExerciseContentCategory.ENDINGCHEERUP;

              return (
                <CardItem
                  key={index}
                  selected={selected}
                  onChange={onChangeSelectedExercises(el.id)}
                  goToDetailPage={() => goToExerciseDetail(el.id)}
                  handleEdit={() => handleEditExercise(el.id)}
                  handleDelete={() => handleDeleteExercise(el.id)}
                  handleDuplicate={() => handleDuplicateExercise(el.id)}
                  hideAction={hideAction}
                  name={el.name}
                  id={el.id}
                  thumbnail={el.thumbnail ?? ''}
                  type={el.category.name}
                  showCheckbox={showCheckbox}
                  level={isWarmupOrCooldownOrCheerup ? undefined : el.level}
                  tag={cardTag(el)}
                />
              );
            })}
          </Grid_6>
          <Pagination total={total.value} queryState={queryState} tableKey={TABLE_KEY.EXERCISES} />
        </>
      ) : (
        <Typography
          variant="h3"
          weight={700}
          style={{ textAlign: 'center', justifyContent: 'center', marginTop: 30 }}
        >
          No data
        </Typography>
      )}

      <ConfirmModal
        modalKey={MODAL_KEY.DELETE_EXERCISE}
        content={'Deleting will also remove them from all existing lessons.'}
        header={`Delete ${selectedExercisesTotal === 0 ? '' : selectedExercisesTotal} exercises`}
        onCancel={() => closeModal(MODAL_KEY.DELETE_EXERCISE)}
        onSubmit={() => {
          isEmpty(selectedExercises) ? onDeleteExercise() : handleDelete();
          closeModal(MODAL_KEY.DELETE_EXERCISE);
        }}
      />

      <LevelLessonModal
        onSubmit={handleAddToLesson}
        setLevelLesson={setLevelLesson}
        levelLesson={levelLesson}
        onCancel={onCancel}
      />
    </div>
  );
};
